export type ProductLiftIdentifyData = { uid: string; email: string; name: string };

declare global {
    interface Window {
        ProductLiftIdentify: (data: ProductLiftIdentifyData) => void;
        ProductLift: {
            ssoToken: string;
        };
    }
}

const identify = (data: ProductLiftIdentifyData) => {
    window.ProductLiftIdentify(data);
};

const onSSOToken = (callback: (ssoToken: string) => void) => {
    const ssoInterval = setInterval(() => {
        if (window.ProductLift.ssoToken) {
            clearInterval(ssoInterval);
            callback(window.ProductLift.ssoToken);
        }
    }, 200);
};

export default { identify, onSSOToken };
